import {
    buildSchema,
} from "@camberi/firecms";

const teacherSchema = buildSchema({
    name: "teachers",
    properties: {
        title: {
            dataType: "string",
            title: "Title",
            description:"Teacher's designation",
            validation: {
                required: true
            }
        },
        name: {
            dataType: "string",
            title: "Name",
            validation: {
                required: true
            }
        },
        description: {
            dataType: "string",
            title: "About teacher",
            validation: {
                required: true
            },
            config:{
                multiline: true,
            }
        },
        link: {
            dataType: "string",
            title: " Link",
            validation: {
                required: true
            },
            config:{
                url:true
            }
        },
        order: {
            dataType: "number",
            title: " Order",
            description:"According to order, app displays teacher's profile",
            validation: {
                required: true,
                min:0,
                negative:false
            }
        },
        image: {
            dataType: "string",
            title: " Image",
            validation: {
                required: true
            },
            config: {
                storageMeta: {
                    mediaType: "image",
                    storagePath: "images",
                    acceptedFiles: ["image/*"],
                    storeUrl: true,
                }
            }
        },
        updated_at: {
            dataType: "timestamp",
            title: "Updated at",
            validation: {
                required: true
            }
        },
        publish: {
            dataType: "boolean",
            title: "Publish",
            validation: {
                required: true
            }
        },
        
    }
});

teacherSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default teacherSchema;